<div class="row">
  <div class="col-md-12 d-flex flex-column">
    <ng-container *appHasPermissions="createCommentRequiredSecurity">
      <span class="margin-bottom-md">{{ 'required_fields_label' | translate }}</span>
      <app-post-manual-audit-issue-comment
        class="mb-2"
        data-test-id="comment-composer"
        [workspaceId]="workspaceId"
        [digitalPropertyId]="digitalPropertyId"
        [evaluationScanId]="evaluationScanId"
        [manualAuditIssueId]="manualAuditIssueId"
        [manualAuditFindingId]="manualAuditFindingId"
        (postedComment)="getComments()"
      ></app-post-manual-audit-issue-comment>
    </ng-container>
    <app-view-comments
      [comments]="comments"
      [userOrigin]="userOrigin"
      [evaluationOrigin]="evaluationOrigin"
      (requestCommentDeletion)="requestCommentDeletion($event)"
      (requestCommentEdit)="editComment($event)"
    >
    </app-view-comments>
  </div>
</div>
